<template>
  <div class="bg-head">
    <div class="warp">
      <div class="logo-lang">
        <a :href="domain"><img class="logo" src="../../static/images/logo.png" alt="logo"></a>
        <div class="inline-block pull-right dropdown-bar">
          <a :href="`${domain}BaigolfClub.php`" class="bg-club"></a>
          <a :href="`${domain}shopping_mall.php?act=goods_list`" class="bg-shopping"></a>
          <div class="inline-block drop-down">
            <div class="drop-main bg-club short-icon service"></div>
            <div class="drop-down-box phone-call">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -45px"><div class="x_triangle"></div></div>
                <div><span>{{$t('header.header_internal_call')}}<!-- 中国大陆 --></span><b>400-809-1328</b></div>
                <div><span>{{$t('header.header_abroad_call')}}<!-- 海外 --></span><b>+86-20-3846-8827</b></div>
              </div>
            </div>
          </div>
          <div class="inline-block drop-down">
            <div class="drop-main bg-club short-icon phone"><!--  {{$t('header.header_app_download')}} 手机版 --></div>
            <div class="drop-down-box img-box" :style="{width: lan_type == 1 ? '270px' : '100px'}">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -45px"><div class="x_triangle"></div></div>
                <div class="inline-block">
                  <div>{{$t('header.down_load_app')}}<!-- 扫描二维码下载 --></div>
                  <img :src="`${img_base}temp/bgscan_img.png`">
                </div><div class="inline-block pull-right" v-if="lan_type == 1">
                  <div>公众号 百高之旅</div>
                  <img :src="`${img_base}temp/bgscan_img2.png`">
                </div>
              </div>
            </div>
          </div>
          <div class="inline-block drop-down">
            <div class="drop-main"><img :src="img_base + 'header/' + lang[currentLang].flag" alt=""></div>
            <div class="drop-down-box lang">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -35px"><div class="x_triangle"></div></div>
                <div class="lang-head">{{$t('header.header_all_language')}}<!-- 所有语言 --></div>
                <div class="lang-body">
                  <a :href="domain + '?lan=' + item.type" :data-type="item.type" v-for="item in lang"><img :src="img_base + 'header/' +item.flag" alt="" width="34" height="22">{{item.text}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="inline-block drop-down">
            <div class="drop-main"> <span>{{company}} {{currency_code}}</span> </div>
            <div class="drop-down-box lang currency-box">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -35px"><div class="x_triangle"></div></div>
                <div class="lang-body">
                  <a href="javascript:;" @click="changeCurrency(item.currency)" :data-type="item.type" v-for="(item,index) in lang" v-if="index<=4">{{item.currency_text}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="inline-block drop-down">
            <div class="drop-main bg-club short-icon user">{{$store.getters.getUserData.user_name}}</div>
            <div class="drop-down-box longin" v-if="!$store.getters.getUserData.is_login">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -20px"><div class="x_triangle"></div></div>
                <div class="login-box">
                  <div class="longin-reg">{{$t('header.login_discount_tip')}}<!-- 登录获得积分和其它独家优惠 --></div>
                  <a :href="domain + 'login.php'" class="search-btn inline-block text-center">{{$t('header.header_login')}}<!-- 登录 --></a>
                  <div class="longin-reg">{{$t('header.if_bg_user')}}<!-- 还不是百高会员？ --></div>
                  <a :href="domain + 'register.php'" class="search-btn inline-block text-center">{{$t('header.header_register')}}<!-- 注册 --></a>
                </div>
                <a :href="domain + 'order_nm.php'" class="notmember-order text-center">{{$t('header.header_notmember_order')}}<!-- 非会员订单 --></a>
              </div>
            </div>
            <div class="drop-down-box lang login-detail" v-if="$store.getters.getUserData.is_login">
              <div class="box-wrap-content">
                <div class="x_triangle_wrapper" style="top: -40px"><div class="x_triangle"></div></div>
                <div class="lang-body">
                  <a :href="`${domain}member.php`">{{$t('header.center_user')}}<!-- 会员中心 --></a>
                  <a :href="`${domain}order_list.php?op=course&mode=1`">{{$t('header.header_my_order')}}<!-- 我的订单 --></a>
                  <a :href="`${domain}point_list.php`">{{$t('header.header_point')}}<!-- 我的积分 --></a>
                  <a :href="`${domain}reset_pw.php?op=edit`">{{$t('header.header_edit_password')}}<!-- 修改密码 --></a>
                  <a :href="`${domain}login.php?op=logout`">{{$t('header.header_logout')}}<!-- 退出登录 --></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="book-type" v-if="$store.getters.getRouteName !== 'HotelBooking' && $store.getters.getRouteName !== 'Payment'">
        <div class="type-wrapper" v-for="(item, index) in book_type" :key="index" :class="[item.active ? 'active': '', item.class_name]">
          <a :href="item.url" class="book-item" >{{item.text}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  let lang = [
    {
      type: 'zh_cn',
      flag: 'china.gif',
      text: '简体中文',
      currency: 'CNY',
      value: 1,
      currency_text: '人民币（CNY）'
    },
    {
      type: 'ja_jp',
      flag: 'japanese.gif',
      text: '日本語',
      currency: 'JPY',
      value: 2,
      currency_text: '日本円（JPY）'
    },
    {
      type: 'zh_hk',
      flag: 'hongkong.png',
      text: '繁體中文',
      currency: 'HKD',
      value: 3,
      currency_text: '港幣（HKD）'
    },
    {
      type: 'en_us',
      flag: 'english.gif',
      text: 'English',
      currency: 'USD',
      value: 4,
      currency_text: 'USD'
    },
    {
      type: 'ko_kr',
      flag: 'korean.gif',
      text: '한국어',
      currency: 'KRW',
      value: 5,
      currency_text: '한국 원（KRW）'
    },
    {
      type: 'th_th',
      flag: 'thailand.jpg',
      text: 'ภาษาไทย',
      currency: 'THB',
      value: 6,
      currency_text: 'ไทยบาท（THB）'
    },
    {
      type: 'de_de',
      flag: 'german.png',
      text: 'Deutsch',
      currency: 'EUR',
      value: 7,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'fr_fr',
      flag: 'french.png',
      text: 'France',
      currency: 'EUR',
      value: 8,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'es_es',
      flag: 'spain.png',
      text: 'España',
      currency: 'EUR',
      value: 9,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'sv_se',
      flag: 'sweden.png',
      text: 'Sverige',
      currency: 'EUR',
      value: 10,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'nl_nl',
      flag: 'holland.png',
      text: 'Nederland',
      currency: 'EUR',
      value: 11,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'vi_vn',
      flag: 'vietnam.png',
      text: 'ViệtNam',
      currency: 'EUR',
      value: 12,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'ms_my',
      flag: 'malaysia.png',
      text: 'Malaysia',
      currency: 'EUR',
      value: 13,
      currency_text: 'Euro（EUR）'
    },
    {
      type: 'id_id',
      flag: 'indonesia.png',
      text: 'Indonesia',
      currency: 'EUR',
      value: 14,
      currency_text: 'Euro（EUR）'
    }
  ]
  let domain =  process.env.WEB_HOST;
  let currency_code_obj = {
    'CNY': '¥',
      'USD': '$',
      'KRW': '₩',
      'HKD': 'HK$',
      'JPY': '¥',
  };
  export default {
    name: '',
    data() {
      return {
        domain: domain,
        img_base: 'https://www.baigolf.com/templates/images/',
        lang: lang,
        user_data: {},
        currentLang: localStorage.getItem('lan_type') - 1,
        book_type: [
          // {
          //   text: this.$i18n.t('header.home'),
          //   url: domain,
          //   active: false,
          // },
          {
            text: this.$i18n.t('header.Golf'),
            url: domain + 'course',
            active: false,
            class_name: 'golf'
          },
          {
            text: this.$i18n.t('header.SKIING'),
            url: domain + 'ski',
            active: false,
            class_name: 'ski',
          },
          {
            text: this.$i18n.t('header.hotel'),
            url: domain + 'hotel',
            active: true,
            class_name: 'hotel'
          },
          {
            text: this.$i18n.t('header.PLAY_STAY'),
            url: domain + 'travel',
            active: false,
            class_name: 'travel'
          },
          {
            text: this.$i18n.t('header.RENT_CAR_HOME'),
            url: domain + 'car',
            active: false,
            class_name: 'rent_car'
          }
        ],
        currency_code: localStorage.getItem('currency_code'),
        company: currency_code_obj[localStorage.getItem('currency_code')],
        lan_type: localStorage.getItem('lan_type'),
      }
    },
    methods: {
      changeCurrency(currency){
        // 当前货币仍有余额时，不允许切换货币
        if (this.$store.getters.getUserData.is_login) {
          this.$http.checkChangeCurrency().then(resp => {
            if (resp && resp.data && !resp.data.can_change_currency) {
              this.$toast(this.$t('header.currency_balance_limit'));
              return;
            }

            this.doChangeCurrency(currency);
          });
        } else {
          this.doChangeCurrency(currency);
        }
      },
      doChangeCurrency(currency){
        let routeParams = this.$route;
        let newQuery = Object.assign({}, routeParams.query, {currency_code: currency});

        this.$router.push({name: routeParams.name, params:routeParams.params, query: newQuery })
        window.location.reload();
      }
    },
    mounted () {
      this.user_data = this.$store.getters.getUserData;
    }
  }
</script>
<style lang="scss" scoped>
  @import './head.scss';
</style>



// WEBPACK FOOTER //
// src/components/BgHead.vue